import Axios from "axios";
var ShopNewDemandService = (function () {
    function ShopNewDemandService() {
    }
    ShopNewDemandService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/demand_goods/list", { params: params });
    };
    ShopNewDemandService.prototype.handle = function (data) {
        return Axios.post("supplierclientapi/demand_goods/do_operation", data);
    };
    ShopNewDemandService.prototype.getStatus = function () {
        return Axios.post("supplierclientapi/demand_goods/status_list");
    };
    ShopNewDemandService.createInstance = function () {
        ShopNewDemandService.getInstance();
    };
    ShopNewDemandService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return ShopNewDemandService;
}());
export default ShopNewDemandService;
